import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

export const StyledInput = styled.input.attrs(props => ({
  'data-testid': props['data-testid']
}))`
  padding: 15px;
  height: 50px;
  font-size: 14px;
  margin-bottom: 15px;
  width: 100%;
  border: 1px solid ${commonPalette.borderGrey};
  border-radius: 3px;
  outline: none;
  ${p =>
    p.isDesktop &&
    `
    flex: 1;
  `}

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${commonPalette.txLightGrey};
  }
  :-ms-input-placeholder {
    color: ${commonPalette.txLightGrey};
  }

  &:focus {
    border: 1px solid ${commonPalette.sgGreen};
    -webkit-box-shadow: 0px 0px 3px 1px ${commonPalette.sgGreen};
    box-shadow: 0px 0px 3px 1px ${commonPalette.sgGreen};
  }
`;

export const StyledLabel = styled.div`
  ${p =>
    p.isDesktop &&
    `
     margin-bottom: 0.5rem;
  `}
  ${p =>
    !p.isDesktop &&
    `
     line-height: 0;
     margin-top: 2rem;
     margin-bottom: 1rem;
  `}
`;
